/**
 * PackageGeneralSettingsCtrl controller
 * Add/edit package
 */

import { GET_TIMEZONES } from 'app/core/constants'

/**
 * PackageGeneralSettingsCtrl controller
 *
 * @class PackageGeneralSettingsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:PackageGeneralSettingsCtrl
 */
/* @ngInject */
export default function PackageGeneralSettingsCtrl ($sce, $scope, $uibModal, $location, alertSvc, NetworkChannelLink, NetworkThemeLink, NetworkColorScheme, Channel, Layout, pckg, Network, subscriptions, inapp, storageSvc, authSvc, scope) {
  const vm = this

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:PackageGeneralSettingsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  vm.backgroundColor = 'Dark'

  vm.mapPlatforms = {
    TV: 'stb',
    WEB: 'laptop',
    TABLET: 'tablet',
    MOBILE: 'mobile'
  }

  vm.platforms = {
    stb: {
      icon: 'display',
      label: 'TV',
      type: 'TV',
      index: 0
    },
    laptop: {
      icon: 'laptop',
      label: 'Web',
      type: 'WEB',
      index: 1
    },
    tablet: {
      icon: 'tablet-button',
      label: 'Tablet',
      type: 'TABLET',
      index: 2
    },
    mobile: {
      icon: 'mobile',
      label: 'Mobile',
      type: 'MOBILE',
      index: 3
    }
  }

  vm.background_gradients = [
    {
      label: 'Royal Lilac',
      gradientConfig: {
        colors: [{
          color: '#1C0E34',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Lavender Dawn',
      gradientConfig: {
        colors: [{
          color: '#240E32',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Twilight Iris',
      gradientConfig: {
        colors: [{
          color: '#1A192A',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Icy Blue',
      gradientConfig: {
        colors: [{
          color: '#0E1B22',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Azure Stream',
      gradientConfig: {
        colors: [{
          color: '#0E1E27',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Sand Dune',
      gradientConfig: {
        colors: [{
          color: '#22170E',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Golden Meadow',
      gradientConfig: {
        colors: [{
          color: '#412F0E',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Silken Rose',
      gradientConfig: {
        colors: [{
          color: '#32171C',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Olive Grove',
      gradientConfig: {
        colors: [{
          color: '#2C2F0E',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Mint Breeze',
      gradientConfig: {
        colors: [{
          color: '#0E241B',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    }
  ]
  vm.displaying_background_gradients = [
    {
      label: 'Royal Lilac',
      gradientConfig: {
        colors: [{
          color: '#1C0E34',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Lavender Dawn',
      gradientConfig: {
        colors: [{
          color: '#6E2B99',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Twilight Iris',
      gradientConfig: {
        colors: [{
          color: '#58558F',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Icy Blue',
      gradientConfig: {
        colors: [{
          color: '#386B87',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Azure Stream',
      gradientConfig: {
        colors: [{
          color: '#326C8C',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Sand Dune',
      gradientConfig: {
        colors: [{
          color: '#875B38',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Golden Meadow',
      gradientConfig: {
        colors: [{
          color: '#A66224',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Silken Rose',
      gradientConfig: {
        colors: [{
          color: '#994656',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Olive Grove',
      gradientConfig: {
        colors: [{
          color: '#8A942C',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    },
    {
      label: 'Mint Breeze',
      gradientConfig: {
        colors: [{
          color: '#368A67',
          percentage: 0
        }, {
          color: '#111111',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 180
      }
    }
  ]

  vm.main_gradients = [
    {
      label: 'Royal Lilac',
      gradientConfig: {
        colors: [{
          color: '#BB86FC',
          percentage: 0
        }, {
          color: '#360A5E',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 135
      }
    },
    {
      label: 'Lavender Dawn',
      gradientConfig: {
        colors: [{
          color: '#DF7FF5',
          percentage: 0
        }, {
          color: '#4D0A5B',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 135
      }
    },
    {
      label: 'Twilight Iris',
      gradientConfig: {
        colors: [{
          color: '#7668C6',
          percentage: 0
        }, {
          color: '#262336',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 135
      }
    },
    {
      label: 'Icy Blue',
      gradientConfig: {
        colors: [{
          color: '#7CB8DC',
          percentage: 0
        }, {
          color: '#0A3A4B',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 135
      }
    },
    {
      label: 'Azure Stream',
      gradientConfig: {
        colors: [{
          color: '#3F99D3',
          percentage: 0
        }, {
          color: '#0A3F57',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 135
      }
    },
    {
      label: 'Sand Dune',
      gradientConfig: {
        colors: [{
          color: '#DCA268',
          percentage: 0
        }, {
          color: '#412A0A',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 135
      }
    },
    {
      label: 'Golden Meadow',
      gradientConfig: {
        colors: [{
          color: '#FDA700',
          percentage: 0
        }, {
          color: '#9E5007',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 135
      }
    },
    {
      label: 'Silken Rose',
      gradientConfig: {
        colors: [{
          color: '#F05567',
          percentage: 0
        }, {
          color: '#682429',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 135
      }
    },
    {
      label: 'Olive Grove',
      gradientConfig: {
        colors: [{
          color: '#A6BC00',
          percentage: 0
        }, {
          color: '#56650A',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 135
      }
    },
    {
      label: 'Mint Breeze',
      gradientConfig: {
        colors: [{
          color: '#40B98D',
          percentage: 0
        }, {
          color: '#0A3A4B',
          percentage: 100
        }],
        type: 'LINEAR',
        angle: 135
      }
    }
  ]

  vm.additional_colors = [
    { label: 'Royal Lilac', color: '#BB86FC' },
    { label: 'Lavender Dawn', color: '#DF7FF5' },
    { label: 'Twilight Iris', color: '#7668C6' },
    { label: 'Icy Blue', color: '#7CB8DC' },
    { label: 'Azure Stream', color: '#3F99D3' },
    { label: 'Sand Dune', color: '#DCA268' },
    { label: 'Golden Meadow', color: '#FDA700' },
    { label: 'Silken Rose', color: '#F05567' },
    { label: 'Olive Grove', color: '#A6BC00' },
    { label: 'Mint Breeze', color: '#40B98D' }
  ]

  vm.deviceSettings_const = {
    labels: {
      liveEventEnabled: 'Events',
      epgEnabled: 'EPG',
      catchupEnabled: 'Catchup',
      tvEnabled: 'Live',
      vodEnabled: 'Movies',
      tvShowEnabled: 'Series'
    }
  }

  vm.defaultSchemes = [
    {
      label: 'Royal Lilac (Default)',
      backgroundStyle: {
        gradientConfig: {
          colors: [{
            color: '#1C0E34',
            percentage: 0
          }, {
            color: '#111111',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 180
        },
        type: 'GRADIENT'
      },
      mainStyle: {
        gradientConfig: {
          colors: [{
            color: '#BB86FC',
            percentage: 0
          }, {
            color: '#360A5E',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 135
        },
        type: 'GRADIENT'
      },
      additionalStyle: {
        color: '#BB86FC',
        type: 'COLOR'
      },
      secondaryStyle: {
        color: '#BB86FC',
        type: 'COLOR'
      },
      active: true
    },
    {
      label: 'Lavender Dawn',
      backgroundStyle: {
        gradientConfig: {
          colors: [{
            color: '#240E32',
            percentage: 0
          }, {
            color: '#111111',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 180
        },
        type: 'GRADIENT'
      },
      mainStyle: {
        gradientConfig: {
          colors: [{
            color: '#DF7FF5',
            percentage: 0
          }, {
            color: '#4D0A5B',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 135
        },
        type: 'GRADIENT'
      },
      additionalStyle: {
        color: '#DF7FF5',
        type: 'COLOR'
      },
      secondaryStyle: {
        color: '#DF7FF5',
        type: 'COLOR'
      }
    },
    {
      label: 'Twilight Iris',
      backgroundStyle: {
        gradientConfig: {
          colors: [{
            color: '#1A192A',
            percentage: 0
          }, {
            color: '#111111',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 180
        },
        type: 'GRADIENT'
      },
      mainStyle: {
        gradientConfig: {
          colors: [{
            color: '#7668C6',
            percentage: 0
          }, {
            color: '#262336',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 135
        },
        type: 'GRADIENT'
      },
      additionalStyle: {
        color: '#7668C6',
        type: 'COLOR'
      },
      secondaryStyle: {
        color: '#7668C6',
        type: 'COLOR'
      }
    },
    {
      label: 'Icy Blue',
      backgroundStyle: {
        gradientConfig: {
          colors: [{
            color: '#0E1B22',
            percentage: 0
          }, {
            color: '#111111',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 180
        },
        type: 'GRADIENT'
      },
      mainStyle: {
        gradientConfig: {
          colors: [{
            color: '#7CB8DC',
            percentage: 0
          }, {
            color: '#0A3A4B',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 135
        },
        type: 'GRADIENT'
      },
      additionalStyle: {
        color: '#7CB8DC',
        type: 'COLOR'
      },
      secondaryStyle: {
        color: '#7CB8DC',
        type: 'COLOR'
      }
    },
    {
      label: 'Azure Stream',
      backgroundStyle: {
        gradientConfig: {
          colors: [{
            color: '#0E1E27',
            percentage: 0
          }, {
            color: '#111111',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 180
        },
        type: 'GRADIENT'
      },
      mainStyle: {
        gradientConfig: {
          colors: [{
            color: '#3F99D3',
            percentage: 0
          }, {
            color: '#0A3F57',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 135
        },
        type: 'GRADIENT'
      },
      additionalStyle: {
        color: '#3F99D3',
        type: 'COLOR'
      },
      secondaryStyle: {
        color: '#3F99D3',
        type: 'COLOR'
      }
    },
    {
      label: 'Sand Dune',
      backgroundStyle: {
        gradientConfig: {
          colors: [{
            color: '#22170E',
            percentage: 0
          }, {
            color: '#111111',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 180
        },
        type: 'GRADIENT'
      },
      mainStyle: {
        gradientConfig: {
          colors: [{
            color: '#DCA268',
            percentage: 0
          }, {
            color: '#412A0A',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 135
        },
        type: 'GRADIENT'
      },
      additionalStyle: {
        color: '#DCA268',
        type: 'COLOR'
      },
      secondaryStyle: {
        color: '#DCA268',
        type: 'COLOR'
      }
    },
    {
      label: 'Golden Meadow',
      backgroundStyle: {
        gradientConfig: {
          colors: [{
            color: '#412F0E',
            percentage: 0
          }, {
            color: '#111111',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 180
        },
        type: 'GRADIENT'
      },
      mainStyle: {
        gradientConfig: {
          colors: [{
            color: '#FDA700',
            percentage: 0
          }, {
            color: '#9E5007',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 135
        },
        type: 'GRADIENT'
      },
      additionalStyle: {
        color: '#FDA700',
        type: 'COLOR'
      },
      secondaryStyle: {
        color: '#FDA700',
        type: 'COLOR'
      }
    },
    {
      label: 'Silken Rose',
      backgroundStyle: {
        gradientConfig: {
          colors: [{
            color: '#32171C',
            percentage: 0
          }, {
            color: '#111111',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 180
        },
        type: 'GRADIENT'
      },
      mainStyle: {
        gradientConfig: {
          colors: [{
            color: '#F05567',
            percentage: 0
          }, {
            color: '#682429',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 135
        },
        type: 'GRADIENT'
      },
      additionalStyle: {
        color: '#F05567',
        type: 'COLOR'
      },
      secondaryStyle: {
        color: '#F05567',
        type: 'COLOR'
      }
    },
    {
      label: 'Olive Grove',
      backgroundStyle: {
        gradientConfig: {
          colors: [{
            color: '#2C2F0E',
            percentage: 0
          }, {
            color: '#111111',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 180
        },
        type: 'GRADIENT'
      },
      mainStyle: {
        gradientConfig: {
          colors: [{
            color: '#A6BC00',
            percentage: 0
          }, {
            color: '#56650A',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 135
        },
        type: 'GRADIENT'
      },
      additionalStyle: {
        color: '#A6BC00',
        type: 'COLOR'
      },
      secondaryStyle: {
        color: '#A6BC00',
        type: 'COLOR'
      }
    },
    {
      label: 'Mint Breeze',
      backgroundStyle: {
        gradientConfig: {
          colors: [{
            color: '#0E241B',
            percentage: 0
          }, {
            color: '#111111',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 180
        },
        type: 'GRADIENT'
      },
      mainStyle: {
        gradientConfig: {
          colors: [{
            color: '#40B98D',
            percentage: 0
          }, {
            color: '#0A3A4B',
            percentage: 100
          }],
          type: 'LINEAR',
          angle: 135
        },
        type: 'GRADIENT'
      },
      additionalStyle: {
        color: '#40B98D',
        type: 'COLOR'
      },
      secondaryStyle: {
        color: '#40B98D',
        type: 'COLOR'
      }
    }
  ]

  // Feature block
  /**
   * Get devices settings
   */
  pckg._getDevicesSettings().then(res => {
    $scope.loading = false
    vm.logo = res.logos.STB
  })

  /**
   * Check FF
   *
   * @memberof mwApp/packages.controller:PackageGeneralSettingsCtrl
   * @type {mwApp/auth.service}
   */
  vm.authSvc = authSvc

  vm.PROVIDER = window.ENV.APP_PROVIDER

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Default Package for in-app registration
   *
   * @memberof mwApp/packages.controller:PackageGeneralSettingsCtrl
   * @type {number}
   */
  vm.inappNetworkId = !inapp?.multiorgEnabled && inapp?.inAppRegistrationSettings?.enabled && inapp.inAppRegistrationSettings.network?.id

  /**
   * Default Package for Guest Mode
   *
   * @memberof mwApp/packages.controller:SubscriptionSettingsCtrl
   * @type {number}
   */
  vm.guestNetworkId = !inapp?.multiorgEnabled && inapp?.guestModeSettings?.enabled && inapp.guestModeSettings.network?.id

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:PackageGeneralSettingsCtrl
   * @type {Boolean}
   */
  vm.isNew = pckg._isNew()

  /**
   * Timezones
   *
   * @memberof mwApp/packages.controller:PackageGeneralSettingsCtrl
   * @type {String[]}
   */
  GET_TIMEZONES().to(vm.timezones = [])

  /**
   * Screen saver
   *
   * @memberof mwApp/settings.controller:PackageGeneralSettingsCtrl
   * @type {Number}
   */
  vm.defaultNetworkScreenSaver = 0

  /**
   * System timezone
   *
   * @memberof mwApp/settings.controller:PackageGeneralSettingsCtrl
   * @type {String}
   */
  vm.systemTimezone = ''

  vm.requestSettings = true
  vm.tvRadioEpgEnabled = false

  pckg.listingType = pckg.listingType || 'Sequence'

  /**
   * Update package/network
   *
   * @memberof mwApp/packages.controller:PackageGeneralSettingsCtrl
   */
  vm.save = function () {
    vm.setDisable()
    // save package
    const logos = vm.logo ? { STB: vm.logo } : {}

    Promise.all([pckg._saveDevicesSettings({
      logos
    }), NetworkColorScheme.saveColorScheme(new NetworkColorScheme(vm.colorScheme), vm.pckg.id)])
      .then(() => {
        alertSvc.alert('Organization settings updated', 'success')
        vm.location.reload()
      })
      .finally(() => {
        vm.unsetDisable()
      })
  }

  /**
   * Upload logo
   *
   * @memberOf mwApp/channels.controller:PackageGeneralSettingsCtrl
   * @param file
   * @function
   */
  vm.uploadLogo = (file) => {
    $scope.form.$setDirty()
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 2097152) {
        alertSvc.alert('File bigger than 2 MB', 'danger')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (this.width < 500 || this.height < 294) {
        alertSvc.alert('Logo is less than minimum size: 500x294', 'danger')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return upload(file, {
        logo: 'STB'
      }).then((response) => {
        vm.logo = response.data.resourceUrl
      }).finally(() => {
        $scope.$broadcast('dndfile.clear', true)
      })
    }
    img.src = objectUrl
  }

  /**
   * Base upload method
   *
   * @param file
   * @param {Object} params
   * @returns {Promise}
   */
  function upload (file, params) {
    return pckg._uploadFileNetwork(file, params)
  }

  vm.hasFlag = (flag) => {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Delete device logo and background
   *
   * @memberof mwApp/packages.controller:PackageGeneralSettingsCtrl
   * @function
   */
  vm.deleteLogo = () => {
    vm.logo = null
  }

  vm.isOpenBackgroundColor = false
  vm.isOpenMainColor = false
  vm.isOpenAdditionalColor = false
  vm.isOpenSecondaryColor = false
  if (authSvc.hasEnabledFlag('FEATURE_APP_COLOR_SCHEMA_ENABLED')) {
    NetworkColorScheme.getColorScheme(vm.pckg.id).then(res => {
      vm.colorScheme = new NetworkColorScheme(res)
      vm.defaultSchemes.forEach(ds => {
        ds.active = ds.backgroundStyle.gradientConfig.colors[0].color === vm.colorScheme.backgroundStyle.gradientConfig.colors[0].color &&
          ds.mainStyle.gradientConfig.colors[0].color === vm.colorScheme.mainStyle.gradientConfig.colors[0].color &&
          ds.additionalStyle.color === vm.colorScheme.additionalStyle.color &&
          ds.secondaryStyle.color === vm.colorScheme.secondaryStyle.color
        if (ds.active) {
          vm.choosenScheme = angular.copy(ds)
        }
      })
      vm.openCustomScheme = !vm.choosenScheme
    })
  }
  vm.choseColor = (type, color) => {
    const colorKey = type.toLowerCase() + 'Style'
    const isOpenKey = 'isOpen' + type + 'Color'
    if (['Main', 'Background'].includes(type)) {
      if (!vm.colorScheme[colorKey].gradientConfig?.colors?.length || vm.colorScheme[colorKey].gradientConfig.colors[0].color !== color.colors[0].color) {
        $scope.form.$setDirty()
      }
      vm.colorScheme[colorKey].type = 'GRADIENT'
      vm.colorScheme[colorKey].gradientConfig = angular.copy(color)
    } else {
      if (vm.colorScheme[colorKey].color !== color) {
        $scope.form.$setDirty()
      }
      vm.colorScheme[colorKey].type = 'COLOR'
      vm.colorScheme[colorKey].color = color
    }
    vm[isOpenKey] = false
  }

  vm.displayingBackgroundGradient = function (color) {
    let index = 0
    vm.background_gradients.forEach((bg, i) => {
      if (bg.gradientConfig.colors[0].color === color) {
        index = i
      }
    })
    return vm.displaying_background_gradients[index].gradientConfig
  }

  vm.linearGradient = (gradientConfig) => {
    if (gradientConfig?.colors?.length) {
      return `linear-gradient(${gradientConfig.angle}deg, ${gradientConfig.colors[0].color} ${gradientConfig.colors[0].percentage}%, ${gradientConfig.colors[1].color}  ${gradientConfig.colors[1].percentage}%)`
    }
    return ''
  }

  vm.chooseScheme = function (scheme) {
    vm.colorScheme = angular.copy(scheme)
    vm.choosenScheme = angular.copy(scheme)
    vm.defaultSchemes.forEach(s => { s.active = false })
    scheme.active = true
    $scope.form.$setDirty()
    delete vm.colorScheme.label
    vm.openCustomScheme = false
  }

  vm.handleOpenCustomScheme = function () {
    vm.openCustomScheme = true
    vm.defaultSchemes.forEach(ds => {
      ds.active = false
    })
    vm.colorScheme = angular.copy(vm.defaultSchemes[0])
    vm.choosenScheme = null
    $scope.form.$setDirty()
  }

  vm.loadUnsetImage = function () {
    return require('../../img/unsetColor.svg')
  }

  vm.settingValidator = () => {
    const devicesSettings = vm.mapDevicesSettings()

    if (!devicesSettings.tvEnabled && devicesSettings.epgEnabled && devicesSettings.catchupEnabled) {
      return 'Please select also Live feature to activate EPG and Catchup feature for your Subscribers'
    }
    if (!devicesSettings.tvEnabled && devicesSettings.epgEnabled) {
      return 'Please select also Live feature to activate EPG feature for your Subscribers'
    }
    if (!devicesSettings.tvEnabled && devicesSettings.catchupEnabled) {
      return `Please select also ${authSvc.hasEnabledFlag('DEV_FEATURE_CLIENT_APP_CHANNEL_TOGGLE_SPLIT_ENABLED') ? 'Live' : 'Live/EPG'} feature to activate Catchup feature for your Subscribers`
    }
    if (authSvc.hasEnabledFlag('NPVR_UI_ENABLED') && devicesSettings.npvrEnabled && (!devicesSettings.tvEnabled || !devicesSettings.catchupEnabled)) {
      return `Please select ${authSvc.hasEnabledFlag('DEV_FEATURE_CLIENT_APP_CHANNEL_TOGGLE_SPLIT_ENABLED') ? 'Live and Catchup' : 'Radio/EPG and Catchup'} features to activate nPVR for your Subscribers`
    }
    if (!devicesSettings.tvEnabled && !devicesSettings.tvShowEnabled && !devicesSettings.vodEnabled) {
      if (vm.LE_ENABLED) {
        if (!devicesSettings.liveEventEnabled) {
          return 'Please select at least one of the following features: Live, Movies, Series, Live.'
        } else {
          return false
        }
      }
      return 'Please select at least one of the following features: Channels, Movies, TV Shows'
    }
    return false
  }

  vm.changeFeature = function (setting, form) {
    form.$setDirty()
    switch (setting.key) {
      case 'epgEnabled':
      case 'catchupEnabled':
        if (setting.value) {
          vm.devicesSettings.find(set => set.key === 'tvEnabled').value = true
        }
        break
      case 'tvEnabled':
        if (!setting.value) {
          vm.devicesSettings.find(set => set.key === 'epgEnabled').value = false
          vm.devicesSettings.find(set => set.key === 'catchupEnabled').value = false
        }
        break
    }
  }
  vm.loadLayout = function () {
    Layout.loadAll({ networkId: pckg.id }).then((res) => {
      vm.layouts = res
      $scope.loading = false
      vm.layouts.forEach(layout => {
        vm.platforms[vm.mapPlatforms[layout.deviceType]].menuItems = layout.menuItems
        vm.platforms[vm.mapPlatforms[layout.deviceType]].menuItems.forEach(item => { item.isOpen = true })
      })
      scope.platform = Object.keys(vm.platforms)[vm.activePlatformTab]
      scope.menu = vm.platforms[scope.platform].menuItems
    })
  }
  vm.loadLayout()

  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.pckg._publicListUrl)
    }
  }

  $scope.$watch(function () {
    return $location.hash()
  }, () => {
    if ($location.hash() === 'general') {
      vm.loadLayout()
    }
  })

  $scope.$watch('vm.activePlatformTab', () => {
    if (vm.activePlatformTab !== undefined) {
      scope.platform = Object.keys(vm.platforms)[vm.activePlatformTab]
      scope.menu = vm.platforms[scope.platform].menuItems
    }
  })
}
